import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface InboxItem {
  findingId:   string;
  type:        'FINDING_OPENED' | 'FINDING_RESOLVED';
  severity:    string;
  title:       string;
  body:        string;
  serviceType: string;
  resourceId:  string;
  configId:    string;
  createdAt:   string;
  resolvedAt:  string | null;
  isRead:      boolean;
}

export interface InboxResponse {
  items:       InboxItem[];
  unreadCount: number;
}

@Injectable({ providedIn: 'root' })
export class InboxService {
  private readonly base = `${environment.apiUrl}/api/v1/inbox`;

  readonly unreadCount$ = new BehaviorSubject<number>(0);

  constructor(private readonly http: HttpClient) {}

  load(): Observable<InboxResponse> {
    return this.http.get<InboxResponse>(this.base).pipe(
      tap(res => this.unreadCount$.next(res.unreadCount)),
    );
  }

  markAsRead(findingId: string): Observable<{ success: boolean }> {
    return this.http.patch<{ success: boolean }>(`${this.base}/${findingId}/read`, {}).pipe(
      tap(() => {
        const current = this.unreadCount$.value;
        if (current > 0) this.unreadCount$.next(current - 1);
      }),
    );
  }

  markAllAsRead(): Observable<{ markedCount: number }> {
    return this.http.post<{ markedCount: number }>(`${this.base}/read-all`, {}).pipe(
      tap(() => this.unreadCount$.next(0)),
    );
  }
}
